export default __webpack_public_path__ + "static/media/about-us-why-euler-banner.68ef74f4.jpg";